import React from 'react';

import { IconButton, Theme, Typography, WithStyles, withStyles } from '@material-ui/core';
import IconClose from '@material-ui/icons/Close';

import { useNextyContext } from 'containers/App/hooks';

const styles = (theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 5}px`,
    alignItems: 'center',
    display: 'flex',

    '& > div': {
      marginLeft: 'auto',
    },
  },
  text: {
    color: theme.palette.common.white,
    lineHeight: `${theme.spacing.unit * 5}px`,
  },
  link: {
    color: theme.palette.common.white,
    lineHeight: `${theme.spacing.unit * 5}px`,
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  iconButton: {
    width: 36,
    height: 36,
    color: theme.palette.common.white,
  },
  icon: {
    fontSize: '20px',
  },
});

interface NextyBannerProps extends WithStyles<typeof styles> {}

const NextyBanner = ({ classes }: NextyBannerProps) => {
  const { toggleNextyNextStorage, hideNextyNextBanner } = useNextyContext();

  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.text}>
        We&apos;ve remodeled! Check out our new look. You can
      </Typography>
      &nbsp;
      <Typography onClick={toggleNextyNextStorage} variant="body1" className={classes.link}>
        switch back
      </Typography>
      &nbsp;
      <Typography variant="body1" className={classes.text}>
        at any time, but the new look becomes permanent on July 9th.
      </Typography>
      <div>
        <IconButton className={classes.iconButton} onClick={() => hideNextyNextBanner()}>
          <IconClose className={classes.icon} />
        </IconButton>
      </div>
    </div>
  );
};

export default withStyles(styles)(NextyBanner);
